import { Box } from '@mui/material';

import useProjectsStore from 'src/stores/projects';

import FilterItem from '../FeedFilter/Components/FilterItem';
import { getBundlesFilter } from '../FeedFilter/utils';
import BottomSheetHeader from '../BottomSheetHeader';

export default function BundlesSheet() {
    const { activeProject } = useProjectsStore(({ activeProject }) => ({ activeProject }));
    const bundles = activeProject?.bundles.filter((bundle) => bundle.is_public) || [];

    const item = getBundlesFilter(bundles, true);

    return (
        <Box
            px={1}
            sx={{
                maxHeight: '70vh',
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                    width: '6px',
                },
                '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                    borderRadius: '3px',
                },
                '&::-webkit-scrollbar-thumb': {
                    background: '#c1c1c1',
                    borderRadius: '3px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                    background: '#a8a8a8',
                },
            }}
        >
            <BottomSheetHeader title="Подборки" />
            <FilterItem
                key={item.title}
                {...item}
            />
        </Box>
    );
}
